module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bd-a3ae69dedf0b3ad8fb44f09bb4f11716.svg";